<template>
<div class="GzhManagement">
      <div class="fansmgt-seach" >
                <template>
                    <span style="margin-right:20px">关联时间</span>
                    <el-date-picker class="item" v-model="searchData.time.date" type="daterange" align="right" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                    <el-input v-model="searchData.selectValue" placeholder="输入姓名" class="marginright" style="width:240px"></el-input>
                    <el-button type="primary" plain style="width:96px" class="marginright" @click="search()">搜索</el-button>
                </template>
            </div>

            <el-table :data="tableData" class="fansmgt-table">
                <el-table-column label="头像/姓名" align="left" width="200">
                    <template slot-scope="scope">
                        <div class="fansmgt-name">
                            <template v-if="scope.row.headimageurl">
                                <img :src="scope.row.headimageurl" alt="img">
                            </template>
                            <template v-else>
                                <img  src="@/common/images/fansmgt/icon_headerimg.png" alt="img">
                            </template>

                            <p>{{scope.row.paname}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="paname" label="公众号" align="center"></el-table-column>
                <el-table-column prop="city" label="地区" align="center"></el-table-column>
                <el-table-column prop="datetime" label="关注时间" align="center" width="200"></el-table-column>
                <el-table-column prop="issubscribe" label="关注状态" align="center"></el-table-column>
                <el-table-column prop="lastsubscribetime" label="最后访问时间" align="center"></el-table-column>
                <!-- <el-table-column label="操作" align="right"></el-table-column> -->
            </el-table>

            <el-pagination
                background
                layout="prev, pager, next"
                :total="rowCount" align="center" @current-change="fPage()" :current-page.sync="currentPage">
            </el-pagination>
    </div>
</template>

<script>
import {findMPThdUserSubscribeInfoList} from '@/api/fansApi' // 引入粉丝管理 api 资源文件
import {getCookie} from '@/common/js/tools'    // 引入 tools 库
import Loading from 'base/loading/loading'    // 引入 loading 组件
import {mapActions} from 'vuex'       // 引入 vuex 组件
import $ from 'jquery';      // 引入 jquery 组件

export default {
    name: 'GzhManagement',
    data() {
        return {
            fansDialogVisible:false,  // 粉丝 dialog
            searchData: {
                tagValue:"",        // 标签值
                time: {             // 开始/结束时间
                    date: ''
                },
                selectValue:'',     // 查询内容
            },
            clickTableData: [], // 记录选中的表单数据
            tableData: [],  // 表单数据
            fansDetailsMsg: {}, // 粉丝详情
            currentPage: 1,     // 初始化页数
            page: 1,            // 页数
            rowCount: 0,        // 数据条数
            apiData: {}         // api数据
        }
    },
    mounted() {
        // 接口参数配置
        this.apiData = {
            page: this.page,
            pagesize: 10
        };

        this.initTableData()
    },
    methods: {
        initTableData() {  // 初始化表单数据
            // 粉丝列表

         // 开启加载
        // this.setLoading(true);
        this.setLoading(true)

        findMPThdUserSubscribeInfoList({
            data: this.apiData,
            success:data => {

                // 关闭加载
                // this.setLoading(false);
                this.setLoading(false)

                // 粉丝列表数据渲染
                this.tableData = data.data.content;
                // 页数设置
                this.rowCount = data.data.pageinfo.rowCount;

                // console.log(data);
            },
            error:data => {
                // 关闭加载
                // this.setLoading(false);
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
        },
        search() {
            // 搜索条件
            let tagValue = this.searchData.tagValue, // 来源条件
                param = this.searchData.time,     // 开始日期 and 结束日期
                begintime = '',
                endtime = '',
                name = "",
                mobileno = ""    // 搜索数据

            if (param.date !== null) {
                begintime = param.date[0]
                endtime = param.date[1]
            }

            this.apiData = {
                nickname: tagValue,
                begintime: begintime,
                endtime: endtime,
                page: this.page,
                pagesize: 10,
            };

            // 粉丝列表
            this.initTableData()
        },
        
        // 分页
        fPage() {
            // 开启加载
            // this.setLoading(true);
            this.setLoading(true)

            let clickPage = $(".el-pagination .active").html()
            this.apiData.page = clickPage

            // 粉丝列表
            this.initTableData()
        },
        ...mapActions ([
            'setLoading'
        ])
   
    },
    filters: {},
    watch: {},
    computed: {},
    components: {Loading}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.GzhManagement {
    span {
            font-size: 14px;
        }

        .el-date-editor {
            margin-right: 20px;
            .el-range-separator {
                line-height: 25px;
                color: #C0C4CC;
            }
        }
        .el-input__icon {
            line-height: 32px;
            height: 32px;
        }
        .el-menu--horizontal>.el-menu-item.is-active {
            color: #409EFF;
        }
        .el-menu--horizontal>.el-menu-item {
            height: 30px;
            line-height: 20px;
        }
        .el-input {
            height: 40px;
        }
        img {
            float:left;
            width: 50px;
            height: 50px;
            border-radius: 100%;
        }
        .fansmgt-table {
            width:100%;
            text-align:center;
            margin-top: 30px;

            .fansmgt-name {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                -webkit-box-pack: start;
                -ms-flex-pack: start;
                justify-content: flex-start;

                p {
                    padding-left: 10px;
                }


            }
            .fansmgt-position {
                .el-button {
                    min-width: auto;
                }
                i {
                    margin: 0 10px;
                    color: #409EFF;
                }
            }
        }


        .fansmgt-seach {
            margin-top: 30px;

            .marginright {
                margin-right: 20px;
            }

            .el-button {
                height: 32px;
            }
        }

        .post-message {
            background: #fff;
        }

        .el-pagination {
            margin-top: 20px
        }
       
}
</style>
